<p-toast key="save-conversation-pms-error" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="container">
            <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
            <div>
                <h1>{{message.summary}}.</h1>
                <p>{{message.detail}}.</p>
                <ng-container *ngIf="message.data.conversationId">
                  <span class="download-link" (click)="downloadPdf(message.data.conversationId)">{{'ui.toast_save_conversation_pms_error.download_conversation' | translate: {id: message.data.conversationId} }}</span>
                </ng-container>
            </div>
        </div>
    </ng-template>
</p-toast>

